<template>
    <ul class="selectedList list-inline mb-2">
        <li v-if="checked.length > 0" class="list-inline-item">
            <strong>Checked:</strong>
        </li>
        <li v-for="job in checked" :key="job.id" class="list-inline-item">
            <span class="badge bg-primary">{{ job.ref }}</span>
        </li>
        <li v-if="checked.length > 0" class="list-inline-item">
            <a href="#" @click.prevent="clearSelection()">Clear?</a>
        </li>
    </ul>
</template>

<script>

/**
 * Owns the bulk selection for the jobs table.
 *
 * The panels that act on the selection (dates, invoices) each read the ticked
 * checkboxes themselves at submit time, so this component is only responsible
 * for showing what is currently selected and for revealing the panels.
 * Keeping it in one place means the list appears once, above every panel,
 * rather than inside whichever one happens to own the state.
 */
export default {

    data () {
        return {
            checked: [],
        }
    },

    mounted() {
        this.toggleBulkPanels();
        this.initialiseDatatable();
    },

    methods: {

        /**
         * Delegated from the document, so the handlers survive a redraw rather
         * than being re-attached to each new set of rows.
         */
        initialiseDatatable() {

            window.jQuery(document).on(
                'change',
                '#datatable-jobs-list .bulk-update-checkbox',
                () => this.syncFromCheckboxes()
            );

            // The table is server-side, so a redraw replaces every row and
            // anything ticked on a previous page is gone from the DOM. Those
            // jobs would not be submitted, so the list empties itself rather
            // than showing a selection that is no longer real.
            window.jQuery(document).on(
                'draw.dt',
                '#datatable-jobs-list',
                () => this.syncFromCheckboxes()
            );

        },

        /**
         * The selection is **read from the checkboxes**, never accumulated
         * alongside them.
         *
         * Adding on tick and filtering on untick looks equivalent and is not.
         * Select-all toggles every box, including ones already ticked, which
         * fired an untick for each of them — so jobs selected *before* pressing
         * select-all dropped straight back out of this list while remaining
         * visibly ticked, and with them the panels, which appear only while
         * something is selected.
         *
         * Reading the DOM cannot drift from what the operator can see, and is
         * idempotent however many events arrive. It is also what the panels
         * themselves do at submit time, so all three now agree by construction.
         */
        syncFromCheckboxes() {

            const checked = [];

            window.jQuery('#datatable-jobs-list .bulk-update-checkbox:checked').each((_, el) => {
                checked.push(JSON.parse(el.value));
            });

            this.checked = checked;
            this.toggleBulkPanels();

        },

        toggleBulkPanels() {
            if (this.checked.length === 0) {
                window.jQuery('#show-bulk-update').hide();
            } else {
                window.jQuery('#show-bulk-update').show();
            }
        },

        clearSelection() {
            window.jQuery('.bulk-update-checkbox:checked').each(function (_, el) {
                el.checked = false;
            });

            window.jQuery('#checkAll').prop('checked', false);

            this.syncFromCheckboxes();
        },

    }
}
</script>
